import { APP_INITIALIZER, Injectable } from '@angular/core';
import { GrowlBrokerService, GrowlType, SdkDictionaryService } from '@dsivd/prestations-ng';
import { of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';

import { RefCadorService } from '../ref-cador/ref-cador.service';
import { RefInfService } from '../ref-inf/ref-inf.service';

@Injectable({
    providedIn: 'root'
})
export class MetaService {
    constructor(
        private growlService: GrowlBrokerService,
        private dictionaryService: SdkDictionaryService,
        private refInfService: RefInfService,
        private refCadorService: RefCadorService
    ) {
    }

    load(): Promise<any> {
        // Pre-load the dictionary.
        // You can load any other meta informations, such as enums from the backend or anything
        // required in the frontend.
        const loadPromises: Promise<any>[] = [];

        loadPromises.push(
            this.dictionaryService.getDictionary().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les éléments du dictionnaire'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        // RefInfService loading

        loadPromises.push(
            this.refInfService.getCivilities().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les civilités'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refInfService.getMaritalStatuses().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les états civils'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refInfService.getResidencePermits().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les types de permis'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refInfService.getCountries().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les pays'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        // RefCadorService loading

        loadPromises.push(
            this.refCadorService.getInitiators().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les initiateurs'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getProjectTypes().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les types de projets'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getRelations().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les relations'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getContactPreferences().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les préférences de contact'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getSituations().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les situations'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getLevelOfEducations().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les niveaux d\'éducations'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getTypeActivities().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les typeActivities'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getDocumentTypes().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les types de document'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getPermisSejour().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les permis de séjour'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        loadPromises.push(
            this.refCadorService.getLibelles().pipe(
                first(),
                map(() => true),
                catchError(() => {
                    this.growlService.addWithType(
                        GrowlType.DANGER,
                        'Impossible de récupérer les libelles'
                    );
                    return of(true);
                })
            ).toPromise()
        );

        return Promise.all(loadPromises);
    }
}

/**
 *
 * @param metaService
 */
export function metaServiceFactory(metaService: MetaService) {
    return () => metaService.load();
}

export const META_SERVICE_PROVIDER = {
    provide: APP_INITIALIZER,
    useFactory: metaServiceFactory,
    multi: true,
    deps: [MetaService]
};
